import React from 'react'
import { Price } from 'lib/shared/components'
import { Spinner } from 'lib/ui/components'
import { useStoreView } from 'hooks/useStoreView'
import { ReactComponent as ShippingSvg } from 'resources/svg/icons/shipping.svg'
import { DEFAULT_CURRENCY_CODE } from 'lib/core/resources/constants'
import { getPackQty } from 'scenes/Product/components/OptionsSection'
import { ItemWrapper } from './styled'

interface Props {
  frequency: number
  packageQty?: string
  setFrequency: (x: number) => void
  setPacksToAdd: (packs: number) => void
  classNameSelected?: string
  qtyPerDay: number
  packsToAdd?: number
  finalPrice: number
  loadingSubscription: boolean
  isFreeShipping: boolean
  packageType?: string
}

export const CustomizationItem: React.FC<Props> = ({
  frequency: itemFrequency,
  packageQty,
  setFrequency,
  setPacksToAdd,
  classNameSelected,
  qtyPerDay,
  packsToAdd,
  finalPrice,
  loadingSubscription,
  isFreeShipping,
  packageType
}) => {
  const piecesQty = packageQty ? parseInt(packageQty) : 0
  const packs = packsToAdd ?? (getPackQty?.(piecesQty, qtyPerDay, itemFrequency)) ?? 0

  const totalPieces = packs * piecesQty
  const { isLivBrite } = useStoreView()

  const handleSelection = () => {
    setFrequency(itemFrequency)
    setPacksToAdd(packs)
  }

  const packageName = packs > 1 ? `${packageType ?? 'Bag'}s` : packageType ?? 'Bag'

  return (
    <ItemWrapper
      onClick={handleSelection}
      className={classNameSelected}
      isLivBrite={isLivBrite}
    >
      {loadingSubscription ? (
        <div className='item__loading'>
          <Spinner />
        </div>
      ) : (
        <>
          {(packsToAdd && packsToAdd > 0) ? (
            <>
              <div className='item__main'>
                <p className='item__shipment'>Ship every {itemFrequency} weeks.</p>
                <div className='item__price'>
                  <Price
                    currency={DEFAULT_CURRENCY_CODE}
                    value={finalPrice}
                  />
                </div>
                <span className='item__price-label'>per shipment</span>
              </div>
              <div className='item__bottom'>
                <p className='item__packs'>
                  {packs} {packageName}
                  <br />
                  {totalPieces} total pieces.
                </p>
              </div>
              {isFreeShipping && (
                <div className='item__tag'>
                  <p className='item__free-shipping'>
                    <ShippingSvg />
                    <span>Free Shipping</span>
                  </p>
                </div>
              )}
            </>
          ) : (
            <h4>
              The pack number needs to be at least 1
            </h4>
          )}
        </>
      )}
    </ItemWrapper>
  )
}
